// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { coreEnvironment } from "./core/core-environment";

export const environment = {
  production: true,
  MAX_UPLOAD_SIZE: 20,
  CGU_URL: "https://www.eemo.fr/cgu_eemo_v1-0/",
  DPE_ATTRIBUTE_NUMBER: "ENERGY_DIAGNOSTIC_ID",
  DPE_ATTRIBUTE_DATE: "ENERGY_DIAGNOSTIC_DATE",
  DPE_ENERGY_ATTRIBUTE_CODE: "ENERGY_COMSUPTION",
  DPE_GES_ATTRIBUTE_CODE: "GREENHOUSE_GAS",
  DPE_ENERGY_CLASSIFICATION_ATTRIBUTE_CODE: "ENERGY_COMSUPTION_CLASSIFICATION",
  DPE_GES_CLASSIFICATION_ATTRIBUTE_CODE: "GREENHOUSE_GAS_CLASSIFICATION",
  BUILDING_YEAR_CODE: "BUILDING_YEAR",
  SURFACE_CODE: "SURFACE",
  SURFACE_LIVING_CODE: "SURFACE_LIVING",
  ROOM_NB_CODE: "ROOMS_NB",
  INSULATION_CODE: "INSULATION",
  WINDOWS_CODE: "WINDOWS",
  CONDO_STATEMENT_CODE: "CONDO_STATEMENT",
  recaptchaEnabled: true,
  recaptchaSiteKey: "6LcIBm8hAAAAANQZ51xjhrD88RgivWrdXnkg7Vxv",
  httpcsEnabled: true,
  httpcsUrl: "https://seal.httpcs.com/certified/js/84029/app.eemo.dev",
  demoHostname: "demo.eemocloud.dev",
  devHostname: "app.eemocloud.dev",
  versionCheckFrequency: 60,
  notificationCheckFrequency: 60,
  dropBoxDomain: "eemocloud.dev",
  alertMessageSuccessHideTimeout: 5,
  alertMessageErrorHideTimeout: 60,
  appLinkIOs:
    "https://apps.apple.com/fr/app/eemo/id1659357706?itsct=apps_box_link&itscg=30200",
  appLinkAndroid:
    "https://play.google.com/store/apps/details?id=com.app4mdigital&gl=FR",
  stripeUrl: "https://dashboard.stripe.com/test",
  WELCOME_ARTICLE_ID_REALTOR: "66c605327c359113ce1aff83",
  WELCOME_ARTICLE_ID_INDIVIDUAL_WITH_SHARE: "67bc99578763d4509bbb5178",
  WELCOME_ARTICLE_ID_INDIVIDUAL: "67bca10ba18c9a5aff254bb5",
  WELCOME_ARTICLE_ID_NOTARY: "67bca2aa9eb0c621bd7dfb4a",
  WELCOME_ARTICLE_ID_PROFESSIONAL: "67bc99578763d4509bbb5178",
  SHARE_INCREASE_VIEW_ARTICLE_ID: "67e14dfc3fb0ea7a22c0efff",
  core: coreEnvironment,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
